<template>
  <div v-if="session.warning && !session.redirecting" class="session-expiry" role="presentation">
    <section role="alertdialog" aria-modal="true" aria-labelledby="session-expiry-title" aria-describedby="session-expiry-description" @keydown.tab="trapFocus">
      <h2 id="session-expiry-title">로그인 시간을 연장하시겠습니까?</h2>
      <p id="session-expiry-description"><strong>{{ countdown }}</strong> 후 로그인이 만료되어 로그인 화면으로 이동합니다.</p>
      <p>계속 작업하려면 로그인 시간을 연장해 주세요. 저장하지 않은 내용은 사라질 수 있습니다.</p>
      <p v-if="session.error" class="session-error" role="alert">{{ session.error }}</p>
      <div class="session-buttons">
        <button @click="logout">로그아웃</button>
        <button ref="extend" class="primary" :disabled="session.busy" @click="extend">{{ session.busy ? '연장 중…' : '로그인 연장' }}</button>
      </div>
    </section>
  </div>
</template>

<script>
import { sessionState, startSessionKeepAlive, checkSession, refreshNow, endSession } from '../utils/session'
export default {
  data: () => ({ session: sessionState, previousFocus: null }),
  computed: { countdown() { return Math.floor(this.session.remaining / 60) + '분 ' + (this.session.remaining % 60) + '초' } },
  watch: {
    '$route.fullPath'() { checkSession() },
    'session.warning'(visible) {
      if (visible) { this.previousFocus = document.activeElement; this.$nextTick(() => { if (this.$refs.extend) this.$refs.extend.focus() }) }
      else if (this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus()
    }
  },
  mounted() {
    startSessionKeepAlive({
      isActive: () => !['/pages/login', '/bannerManager/login'].includes(this.$route.path) && this.$route.matched.length > 0,
      onExpired: reason => {
        const to = this.$route.fullPath
        this.$router.replace({ path: '/pages/login', query: { to, session: reason === 'logout' ? 'logout' : 'expired' } }).catch(() => {})
      }
    })
  },
  methods: {
    extend() { refreshNow().catch(() => {}) },
    logout() { endSession('logout') },
    trapFocus(event) {
      const buttons = Array.from(this.$el.querySelectorAll('button:not(:disabled)'))
      if (!buttons.length) return
      const first = buttons[0], last = buttons[buttons.length - 1]
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus() }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
    }
  }
}
</script>

<style scoped>
.session-expiry{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:20px}
.session-expiry section{background:#fff;color:#222;max-width:460px;width:100%;padding:28px;border-radius:12px;box-shadow:0 12px 50px #0003}
.session-expiry h2{font-size:20px;line-height:1.5;margin:0 0 16px}.session-expiry p{line-height:1.7;margin:10px 0}.session-buttons{display:flex;justify-content:flex-end;gap:10px;margin-top:22px}.session-buttons button{padding:10px 16px;border:1px solid #ccc;border-radius:6px;background:#fff;cursor:pointer}.session-buttons .primary{background:#111;color:#fff;border-color:#111}.session-buttons button:disabled{opacity:.5;cursor:wait}.session-error{color:#a32e17}
</style>
